// extracted by mini-css-extract-plugin
export default {"content__container":"OnboardingContentContainer_content__container__z5glw","content__wrapper":"OnboardingContentContainer_content__wrapper__TwcKh"};